import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bar", "milestone"]
  static values = {
    current: Number
  }

  connect() {
    console.log("Progress bar controller connected")
    console.log("Current value:", this.currentValue)
    // Wait for next frame to ensure DOM is ready
    requestAnimationFrame(() => this.updateProgress())
  }

  updateProgress() {
    const currentLeads = this.currentValue
    const milestones = this.milestoneTargets
    const progressBar = this.barTarget
    const container = this.element

    console.log("Updating progress with leads:", currentLeads)
    console.log("Found milestones:", milestones.length)

    // Get container bounds for relative positioning
    const containerRect = container.getBoundingClientRect()
    const containerLeft = containerRect.left
    const containerWidth = containerRect.width

    // Get milestone positions relative to container
    const positions = milestones.map(milestone => {
      const rect = milestone.getBoundingClientRect()
      const count = parseInt(milestone.dataset.count)
      const relativeCenter = (rect.left - containerLeft) + (rect.width / 2)
      console.log(`Milestone ${count} relative position:`, relativeCenter)
      return {
        count: count,
        center: relativeCenter
      }
    })

    console.log("Container width:", containerWidth)

    // Find the appropriate milestone section
    const currentIndex = positions.findIndex(p => p.count > currentLeads)
    
    let progressWidth
    if (currentIndex === -1) {
      // Beyond last milestone
      progressWidth = containerWidth
    } else if (currentIndex === 0) {
      // Before first milestone
      const firstMilestone = positions[0]
      const ratio = currentLeads / firstMilestone.count
      progressWidth = firstMilestone.center * ratio
    } else {
      // Between milestones
      const prevMilestone = positions[currentIndex - 1]
      const nextMilestone = positions[currentIndex]
      const sectionProgress = (currentLeads - prevMilestone.count) / (nextMilestone.count - prevMilestone.count)
      progressWidth = prevMilestone.center + ((nextMilestone.center - prevMilestone.center) * sectionProgress)
    }

    // Convert to percentage and apply
    const progressPercent = Math.min(100, Math.max(0, (progressWidth / containerWidth) * 100))
    console.log("Setting progress width to:", progressPercent + "%")
    
    progressBar.style.width = `${progressPercent}%`
  }
} 